import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  changeFilterAction,
  clearFilterAction,
} from 'src/routes/SearchPage/actions/filters';
import { isShownLoadingSelector } from 'src/routes/SearchPage/searchStatus/selectors';
import { isEmptyFiltrationSelector } from 'src/routes/SearchPage/store/emptyFiltration/selectors';
import {
  hotelsCountSelector,
  hotelsVisibleLimitSelector,
} from 'src/routes/SearchPage/store/hotels/selectors';
import MobileHotelFilterPopup from './MobileHotelFilterPopup';
import type { FilterProps } from './types';

const mapStateToProps = (state, props: FilterProps) => {
  const { setIsFilterOpened } = props;
  return {
    setIsFilterOpened,
    hotelsCount: hotelsCountSelector(state),
    isFetching:
      isShownLoadingSelector(state) && !isEmptyFiltrationSelector(state),
    isEmptyFiltration: isEmptyFiltrationSelector(state),
    visibleHotelsAmount: hotelsVisibleLimitSelector(state),
  };
};

const mapDispatchToProps = {
  applyFilters: changeFilterAction,
  clearFilters: clearFilterAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(MobileHotelFilterPopup);
